import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { CiUser } from "react-icons/ci";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import EmojiPicker, { EmojiClickData, Theme } from "emoji-picker-react";
import { BiSmile } from "react-icons/bi";

type CommentReplyInputProps = {
  loading: boolean;
  setOnChange: React.Dispatch<React.SetStateAction<boolean>>;
  onChange: boolean;
  communityComment: any;
  setCommunityComment: React.Dispatch<React.SetStateAction<string>>;
  handleSubmit: any;
  textArea: React.MutableRefObject<HTMLTextAreaElement | null>;
  openEdit: number | null;
  index: number;
};
const CommentReplyInput: React.FC<CommentReplyInputProps> = ({
  loading,
  setOnChange,
  onChange,
  communityComment,
  setCommunityComment,
  handleSubmit,
  textArea,
  openEdit,
  index,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [openEmojiPicker, setOpenEmojiPicker] = React.useState(false);

  const onClick = (emojiData: EmojiClickData) => {
    setCommunityComment(
      (inputValue) =>
        inputValue + (emojiData.isCustom ? emojiData.unified : emojiData.emoji)
    );
  };
  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const inputValue = e.target.value.trim();
    setCommunityComment(e.target.value);
    if (inputValue.trim().length > 0) {
      setOnChange(true);
    } else {
      setOnChange(false);
    }
  };

  const user = useSelector((state: any) => state.user.userDetails);

  let _profileImage: string | null = "";

  if (
    user &&
    user?.ecobookProfile &&
    user.ecobookProfile?.profileImage !== null
  ) {
    const profilePic = user?.ecobookProfile?.profileImage;

    if (profilePic !== null && profilePic !== undefined) {
      _profileImage = profilePic;
    }
  }
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useMemo(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const customMargin = screenWidth < 1288 ? "41px" : "53px";

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // console.log(customMargin, 'customMargin' );
  // console.log(screenWidth, 'screenWidth' );
  
  return (
    <div className="w-full justify-between items-center flex bg-white py-2 relative">
      {openEdit !== index &&
        (_profileImage ? (
          <img
            alt=""
            src={ipfsGatewayImage(_profileImage!)}
            className="lg:h-9 lg:w-9 w-6 h-6 rounded-full"
          />
        ) : (
          <div className="lg:h-9 lg:w-9 w-6 h-6 bg-slate-100 flex items-center justify-center rounded-full">
            <CiUser size={12} />
          </div>
        ))}
      <form
        className={`relative flex ${openEdit ? "w-full" : "w-[90%]"}`}
        onSubmit={handleSubmit}
      >
        <textarea
          ref={textArea}
          value={communityComment}
          onChange={handleOnChange}
          placeholder="Add a comment..."
          className={`w-full pt-[9px] h-[34px] pl-2 lg:pl-[20px] pr-[50px] outline-none items-center block font-Poppins text-[10px] j font-normal text-[#646464] rounded-full border text-pretty resize-none ${
            loading ? "disabled:bg-blend-overlay" : ""
          }`}
          disabled={loading}
        />

        <input
          type="submit"
          value="Post"
          className={`${
            onChange
              ? "absolute cursor-pointer visible right-5 top-[8.5px] text-midGreen text-xs font-Poppins font-normal"
              : "hidden"
          }`}
          disabled={loading}
        />

        {/* {loading && (
        <input
          type="button"
          disabled
          value="Post"
          className="absolute right-6 top-[8.5px] text-lightGreyText text-xs font-Poppins font-normal"
        />
      )} */}
      </form>

      <div
        className={`absolute hidden lg:flex `}
        style={{ left: customMargin }}
      >
        <BiSmile
          size={15}
          className="cursor-pointer active:fill-red-200"
          onClick={() => setOpenEmojiPicker(!openEmojiPicker)}
        />
      </div>
      {openEmojiPicker && (
        <div
          className="absolute bottom-16 ease-in-out duration-75 w-[60%] rounded text-[8px] font-Poppins"
          ref={containerRef}
        >
          <EmojiPicker
            onEmojiClick={onClick}
            height={300}
            theme={Theme.AUTO}
            previewConfig={{
              showPreview: false,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CommentReplyInput;